<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  profiles: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <BasicBlock :icon="['far', 'user-friends']">
    <div>
      <div class="flex mb-8">
        <p class="flex-1" :aria-label="$t('global.participants')">
          {{ $t('global.participants') }}
        </p>
      </div>

      <div>
        <div
          v-for="(profile, index) in profiles"
          :key="index"
          class="flex items-center mb-8"
        >
          <img
            class="rounded-full shadow-bottom object-cover border-white border-4 w-[96px] h-[96px] mr-4"
            v-optimized="{ size: 'small', src: profile.displayImage }"
          />
          <p class="h800 text-center" :aria-label="profile.displayName">
            {{ profile.displayName }}
          </p>
        </div>
      </div>
    </div>
  </BasicBlock>
</template>
